export const CHICRUITING_LANDING_PATH = "/chicruiting/company/mypage";

// 기기 문의 상담 랜딩(외부 구글 앱스 스크립트). DeviceInquiry 의 iframe src 로만 사용한다.
// iframe 표시는 스크립트 쪽 setXFrameOptionsMode(ALLOWALL) 설정이 되어 있어야 동작한다.
export const DEVICE_INQUIRY_PATH = "/device-inquiry";
export const DEVICE_INQUIRY_LANDING_URL =
  "https://script.google.com/a/macros/medistream.co.kr/s/AKfycbyy7NwEowtaeIJzPWX3xvMP-rxnDG4RaKo8R7fERDozBob1618KYt6JEO6HNxfuBcnI/exec";

export const URL_MAP = {
  SIGNUP_INTEGRATED: "/signup/integrated",
  SIGNUP_STEP0: "/signup/step0",
  SIGNUP_STEP1: "/signup/step1",
  SIGNUP_STEP2: "/signup/step2",
  PHONE_VERIFY: "/phoneVerify",
  POST: "/post",
  POST_WRITE: "/post/write/:board",
  POST_MODIFY: "/post/modify/:bid",
  POST_ARTICLE: "/post/article/:bid",
  QNA: "/qna/:tab",
  QNA_RANKING: "/qna/ranking",
  QNA_ARTICLE: "/qna/article/:bid",
  QNA_WRITE: "/qna/write/:tab/*",
  QNA_MODIFY: "/qna/modify/:tab/:bid",
};

// Constants
export const CLASS_ROUTE = "class";
export const EDU_ROUTE = "edu";
export const CHANNEL_ROUTE = "channel";
